import _ from 'lodash'

export const FETCHED_NOTIFICATIONS = 'FETCHED_NOTIFICATIONS'
export const FETCHING_NOTIFICATIONS = 'FETCHING_NOTIFICATIONS'
export const READ_NOTIFICATION = 'READ_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'

export const NEW_MESSAGE_WIDGET = 1
export const DELETED_MESSAGE_WIDGET = 2
export const NEW_MESSAGE_COLLECTION = 3
export const DELETED_MESSAGE_COLLECTION = 4
export const USER_ADDED_TO_COLLECTION = 5
export const USER_REMOVED_FROM_COLLECTION = 6
export const EVALUATION_REQUESTED_BY_STUDENT = 7
export const EVALUATION_DONE_BY_TEACHER = 8
export const NEW_PRIVATE_MESSAGE_WIDGET = 90
export const DELETED_PRIVATE_MESSAGE_WIDGET = 100
export const PLANNING_STARTED = 20
export const PLANNING_DELETED = 21
export const PLANNING_TASK_RESCHEDULED = 22
export const ICT_PLANNING_TASK_REMOVED = 23
export const WIDGET_LIKED = 30
export const EVALUATION_IN_1_DAYS = 41
export const EVALUATION_IN_6_DAYS = 46


export function notifications(
  notifications={
    isFetching: true,
    data: [],
    meta: {
      countUnread: 0,
      count: 0,
    }
  },
  action,
) {
  switch (action.type) {
    case FETCHING_NOTIFICATIONS:
      return {
        ...notifications,
        isFetching: true,
        data: (
          action.append ?
          notifications.data :
          []
        ),
      }
    case FETCHED_NOTIFICATIONS:
      return {
        ...notifications,
        isFetching: false,
        data: (
          action.append ?
          [
            ...notifications.data,
            ...action.notifications,
          ] :
          action.notifications
        ),
        meta: action.meta,
      }
    case READ_NOTIFICATION:
      return {
        ...notifications,
        data: _.map(
          notifications.data,
          n => {
            if (n.id === action.notificationId) {
              return {
                ...n,
                notificationStatus: {
                  isRead: true,
                }
              }
            }
            return n
          }
        ),
        meta: {
          ...notifications.meta,
          countUnread: notifications.meta.countUnread - 1,
        }
      }
    case DELETE_NOTIFICATION:
      const notificationToDelete = _.find(notifications.data, {id: action.notificationId})

      return {
        ...notifications,
        data: _.reject(notifications.data, {id: action.notificationId}),
        meta: {
          ...notifications.meta,
          countUnread: (
            notificationToDelete.notificationStatus.isRead ?
            notifications.meta.countUnread :
            notifications.meta.countUnread - 1
          ),
        }
      }
    default:
      return notifications
  }
}
